import { render, staticRenderFns } from "./WacomSignaturePad.vue?vue&type=template&id=5e09840b&"
import script from "./WacomSignaturePad.vue?vue&type=script&lang=js&"
export * from "./WacomSignaturePad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports